export enum StyleValueExtractionMethod {
    Static = "Static",
    Literal = "Literal",
    Mapped = "Mapped",
    Closest = "Closest",
    Continuous = "Continuous",
    Multi = "Multi",
    MappedProperty = "MappedProperty"
}